fragment VideoIndex on Video {
    id
    title
    bunny_id
    views: viewsCount
    bunny_thumbnail
    duration
    slug

    user {
        full_name
        avatar {
            conversions {
                webp_64
            }
        }
    }
}
